import { useEffect, useState } from "react";
import PageTitle from "../../../Components/Layout/UserDashLyout/PageTitle";
import { usePlayerAccount } from "../../../APIContext/PlayerAccountContext";
import Swal from "sweetalert2";
import "./PaymentDetails.css";
import { data } from "react-router-dom";

const PaymentDetails = () => {
  const { fetchPaymentHistory, cancelSubscription } = usePlayerAccount();
  const [packageData, setPackageData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const result = await fetchPaymentHistory();
      if (result) {
        setPackageData(result);
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to fetch packages.",
          confirmButtonColor: "#B79527", // orange / gold
          cancelButtonColor: "#1C1C1C",
        });
      }
    };

    fetchData();
  }, []);

  const handlecancelSubscription = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to cancel this subscription?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#B79527", // orange / gold
      cancelButtonColor: "#1C1C1C",
      confirmButtonText: "Yes, cancel it!",
    }).then((result) => {
      if (result.isConfirmed) {
        let data = {
          sale_id: id,
        };
        cancelSubscription(data);
      } else {
        return;
      }
    });
  };

  return (
    <>
      <PageTitle
        showDescription={true}
        description="Manage your payment information and view transaction history."
        showButton={false}
        title="My Payment Details"
      />
      <div className="profile-detail-container">
        <div className="package-table">
          <div className="table-header">
            <span className="black-text-clip">Package Name</span>
            <span className="black-text-clip">Price ($)</span>
            <span className="black-text-clip">Player</span>
            <span className="black-text-clip">Credits Remaining</span>
            <span className="black-text-clip">Session Type</span>
            <span className="black-text-clip">Package Status</span>
            <span className="black-text-clip">Action</span>
          </div>

          {packageData.length > 0 ? (
            packageData.map((item, index) => (
              <div className="table-row" key={index}>
                <span data-label="Order ID">
                  <span className="package-title-mobile black-text-clip">
                    Package Name:{" "}
                  </span>
                  <span className="black-text-clip">
                    {item.package_name || "-"}
                  </span>
                </span>
                <span data-label="Subscribed Package ">
                  <span className="package-title-mobile black-text-clip">
                    Price ($):{" "}
                  </span>
                  <span className="black-text-clip">{item.amount || "-"}</span>
                </span>
                <span data-label="Credits Remaining">
                  <span className="package-title-mobile black-text-clip">
                    Player:{" "}
                  </span>
                  <span className="black-text-clip">{item.player || "-"}</span>
                </span>
                <span data-label="Next Bill (YYYY-MM-DD)">
                  <span className="package-title-mobile black-text-clip">
                    Credits Remaining:{" "}
                  </span>
                  <span className="black-text-clip">
                    {item.is_unlimited === true
                      ? "Unlimited"
                      : item.remaining_sessions}
                  </span>
                </span>
                <span data-label="Package Status">
                  <span className="package-title-mobile black-text-clip">
                    Session Type{" "}
                  </span>
                  <span className="black-text-clip">
                    {item.package?.is_group_session === true
                      ? "Group"
                      : "Individual"}
                  </span>
                </span>
                <span data-label="Subscription">
                  <span className="package-title-mobile black-text-clip">
                    Status:{" "}
                  </span>
                  <span className="black-text-clip">
                    {item.can_cancel === true &&
                    item.is_unlimited === true &&
                    item.cancel_requested_at !== null
                      ? "Cancel Requested"
                      : item.status}
                  </span>
                </span>
                {item.can_cancel === true &&
                  item.is_unlimited === true &&
                  item.cancel_requested_at === null && (
                    <span data-label="Action">
                      <span className="package-title-mobile black-text-clip">
                        Action:{" "}
                      </span>
                      <button
                        className="cancel-subscription"
                        onClick={() => handlecancelSubscription(item.sale_id)}
                      >
                        <span className="black-text-clip">
                          Cancel Subscription
                        </span>
                      </button>
                    </span>
                  )}
              </div>
            ))
          ) : (
            <div className="no-package">No Packages Available</div>
          )}
        </div>
      </div>
    </>
  );
};
export default PaymentDetails;
